import React from 'react'
import { useStyles } from './style'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import { formatDate, formatDateTime, priceFormatLocal } from 'utils/helper'
import ItemStatus from '../../components/ItemStatus'
import AcknowledgeModal from '../../components/AcknowledgeModal'
import { Divider } from '@mui/material'

const DetailOrder = ({ data, onBack }) => {
  const [openAcknowledge, setOpenAcknowledge] = React.useState(false)
  const [itemData, setItemData] = React.useState({
    image: '',
    productName: '',
    mid: ''
  })

  const styles = useStyles()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <>
      <button className={styles.backButton} onClick={onBack}>
        Back
      </button>
      <div className={styles.boxInfo} style={{ flexDirection: isMobile ? 'column' : 'row' }}>
        <table style={{ width: isMobile ? '100%' : '65%' }}>
          <tr>
            <td>PO Number</td>
            <td>:</td>
            <td>{data.order.order_number}</td>
          </tr>
          <tr>
            <td>Order Date</td>
            <td>:</td>
            <td>{formatDateTime(data.order.created_at)}</td>
          </tr>
          <tr>
            <td>Requestor</td>
            <td>:</td>
            <td>{data.order.customer.name}</td>
          </tr>
          <tr>
            <td>Department</td>
            <td>:</td>
            <td>
              {data.departments && data.departments.length > 0
                ? data.departments[0].department.name
                : '-'}
            </td>
          </tr>
          <tr>
            <td>Cost Center</td>
            <td>:</td>
            <td>
              {data.cost_centers && data.cost_centers.length > 0
                ? data.cost_centers[0].cost_center.name
                : '-'}
            </td>
          </tr>
          <tr>
            <td>HOD</td>
            <td>:</td>
            <td>{data.order?.customer_hod?.name}</td>
          </tr>
          <tr>
            <td>PO Status</td>
            <td>:</td>
            <td>{data.order.status}</td>
          </tr>
        </table>
        <Divider sx={{ width: isMobile ? '100%' : '0', my: isMobile ? 1.5 : 0 }} />
        <div style={{ width: isMobile ? '100%' : '35%' }}>
          <p>{data.order.customer_address.name}</p>
          <p>{data.order.customer_address.phone}</p>
          <p>{data.order.customer_address.address}</p>
        </div>
      </div>
      <div className={styles.boxProduct}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size='small' aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell style={{ minWidth: 340 }}>Product Name</TableCell>
                <TableCell>Qty</TableCell>
                {data.order.status === 'ACKNOWLEDGE' && (
                  <>
                    <TableCell style={{ minWidth: 100 }}>Sent Qty</TableCell>
                    <TableCell style={{ minWidth: 124 }}>Remain Qty</TableCell>
                  </>
                )}
                <TableCell>Unit Price</TableCell>
                <TableCell>Total</TableCell>
                {data.order.status !== 'WAITING APPROVAL HOD' && <TableCell>Item Status</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.order_items.length > 0 &&
                data.order_items.map(item => {
                  const acknowledges = item.order_item_acknowledges?.sort(
                    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
                  )

                  const totalAck = acknowledges?.reduce((acc, curr) => {
                    return acc + curr.quantity
                  }, 0)

                  const isFullyAck = totalAck === item.order_item.quantity
                  const totalSent =
                    item.order_item?.quantity_sent + item.order_item?.quantity_received

                  return (
                    <TableRow
                      key={item.order_item.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell>
                        <div style={{ display: 'flex', gap: 12 }}>
                          <img
                            className={styles.itemImg}
                            src={
                              item.order_item.product.media
                                ? process.env.REACT_APP_FILE_BASE_URL +
                                  '/' +
                                  item.order_item.product.media[0]
                                : '/assets/images/dummy.png'
                            }
                          />
                          <div>
                            <p>{item.order_item.product.name}</p>
                            <table className={styles.itemInfoTable}>
                              <tbody>
                                <tr>
                                  <td style={{ textWrap: 'nowrap' }}>Material ID</td>
                                  <td style={{ padding: '0 6px' }}>:</td>
                                  <td>{item.order_item.product.sku}</td>
                                </tr>
                                <tr>
                                  <td style={{ textWrap: 'nowrap' }}>G/L Account</td>
                                  <td style={{ padding: '0 6px' }}>:</td>
                                  <td>
                                    {(item.general_ledger_accounts ?? [])
                                      .map(gla => gla.general_ledger_account.name)
                                      .join(', ')}
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ textWrap: 'nowrap' }}>PO Reason</td>
                                  <td style={{ padding: '0 6px' }}>:</td>
                                  <td>{item.order_item.po_reason}</td>
                                </tr>
                                {item.order_item.note && (
                                  <tr>
                                    <td style={{ textWrap: 'nowrap' }}>Notes</td>
                                    <td style={{ padding: '0 6px' }}>:</td>
                                    <td>{item.order_item.note}</td>
                                  </tr>
                                )}
                                {item.order_item.expect_date && (
                                  <tr>
                                    <td style={{ textWrap: 'nowrap' }}>Expect Delivery Date</td>
                                    <td style={{ padding: '0 6px' }}>:</td>
                                    <td>{formatDate(item.order_item.expect_date)}</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>{item.order_item.quantity}</TableCell>
                      {data.order.status === 'ACKNOWLEDGE' && (
                        <>
                          <TableCell>{totalSent}</TableCell>
                          <TableCell>{(item.order_item?.quantity ?? 0) - totalSent}</TableCell>
                        </>
                      )}
                      <TableCell style={{ textWrap: 'nowrap' }}>
                        {priceFormatLocal(item.order_item.price)}
                      </TableCell>
                      <TableCell style={{ textWrap: 'nowrap' }}>
                        {priceFormatLocal(item.order_item.total)}
                      </TableCell>
                      {data.order.status !== 'WAITING APPROVAL HOD' && (
                        <>
                          <TableCell>
                            <ItemStatus
                              status={item.order_item.status_hod}
                              isCompleted={isFullyAck}
                              onClick={() => {
                                if (item.order_item.status_hod !== 'ACKNOWLEDGE') return
                                setOpenAcknowledge(true)
                                setItemData({
                                  image: item.order_item.product.media
                                    ? process.env.REACT_APP_FILE_BASE_URL +
                                      '/' +
                                      item.order_item.product.media[0]
                                    : '/assets/images/dummy.png',
                                  productName: item.order_item.product.name,
                                  mid: item.order_item.product.sku,
                                  order_item_acknowledges: item.order_item_acknowledges
                                })
                              }}
                            />
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: 250 }}>
              <p>Total ({data.order.item_qty} items)</p>
              <p>{priceFormatLocal(data.order.total)}</p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: 250 }}>
              <p>Grand Total</p>
              <p>{priceFormatLocal(data.order.grand_total)}</p>
            </div>
          </div>
        </div>
      </div>
      <AcknowledgeModal
        open={openAcknowledge}
        itemData={itemData}
        onClose={() => setOpenAcknowledge(false)}
      />
    </>
  )
}

export default DetailOrder
